<template>
    <div class="index">

        <div class="white-color">

            <br class="no-move"/>

            <b-img class="img" src="../assets/Allgemein.png"></b-img>

            <br class="no-move"/>
            <br class="no-move"/>

            <h5 style="padding-top: 10px" class="no-move smaller-normal-text middle-wave text-dark gray-shadow">LabyHelp
                <strong class="red-dark-color">Group</strong></h5>

            <h1 class="display-title-strong text-dark container">
                Ist mehr als, <br/> ein LabyMod Addon.
            </h1>

            <p class="normal-text-secondary text-white-gray-color container">
                Wir bei LabyHelp versuchen Funktionen in LabyMod einzubauen
                die Spielern Möglichkeiten gibt, sich Sozial zu verknüpfen und schwierige Hürden einfacher zu
                überspringen.
            </p>

            <p style="color: #06c" class="normal-text-secondary"><a style="color: #06c" href="/download"
                                                                    class="normal-text-secondary"><strong>Herunterladen</strong></a>
            </p>


            <br class="no-move"/>
            <br class="no-move"/>


            <div class="container-small">
                <div class="yellow-blass-wait">

                    <br class="no-move"/>
                    <br class="no-move"/>

                    <h1 class="display-title-strong text-dark">

                        Server Integration
                        <b-badge>NEU</b-badge>

                    </h1>

                    <p class="normal-text-title text-dark container">
                        Du bist Server Besitzer und möchtest dein Netzwerk bewerben und außerdem ein exklusives Ⓢ hinter
                        deinem NameTag haben. <a style="color: #06c" href="/server-partner"
                                                 class="normal-text-secondary">Erfahre mehr...</a>
                    </p>


                    <br class="no-move"/>
                    <br class="no-move"/>

                </div>

                <br class="no-move"/>
                <br class="no-move"/>

            </div>

        </div>

        <br class="no-move"/>
        <br class="no-move"/>


        <div class="black-wait">

            <br class="no-move"/>
            <br class="no-move"/>

            <h1 class="display-title-strong purple-black-color">
                LabyHelp besteht aus mehreren Addons.
            </h1>

            <br class="no-move"/>
            <br class="no-move"/>

            <div class="container">

                <b-img class="img" src="../assets/LabyMatch.png"></b-img>

                <b-img class="img" src="../assets/LabyCreators300x300.png"></b-img>

                <br class="no-move"/>
                <br class="no-move"/>

                <p class="display-title-middle text-white">LabyMatch oder LabyCreators sind nur in der Kombination mit
                    LabyHelp
                    verfügbar. <strong>Viele Store Addons bieten mehr Features als manches andere LabyMod
                        Addon.</strong></p>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>


        </div>

        <br class="no-move"/>
        <br class="no-move"/>

        <div class="gold-wait">

            <br class="no-move"/>
            <br class="no-move"/>

            <h1 class="display-title-middle text-dark">
                <strong>LabyHelp Store</strong>
            </h1>


            <h1 class="display-title-middle text-dark">

                Der LabyHelp Addon Store bietet jeden Nutzer weitere Zusatzfeatures und die Entscheidung diese Addons zu
                nutzen
                liegt allein bei dir!

            </h1>

            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <br class="no-move"/>
        <br class="no-move"/>


        <div class="container-small">
            <div class="green-blass-wait">

                <br class="no-move"/>
                <br class="no-move"/>

                <h1 class="display-title-strong text-dark">

                    Bewirb deine Social Media.

                </h1>

                <p class="normal-text-title text-dark container">
                    Füge deinen <strong>Instagram, Discord, Twitch, TikTok, Twitter oder Youtube</strong> Namen hinzu
                    und lasse andere Spieler über das Interaktionsmenü oder über das LabyHelp Profil dein Account
                    folgen.
                </p>


                <br class="no-move"/>
                <br class="no-move"/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <div class="container-small">
            <div class="yellow-blass-wait">

                <br class="no-move"/>
                <br class="no-move"/>

                <h1 class="display-title-strong text-dark">

                    Kopiere Cosmetic Designs.

                </h1>

                <p class="normal-text-title text-dark container">
                    Du hast die Möglichkeit dir die <strong>Bandanas, Capes, Skins</strong> per Command oder durch das
                    Interaktionsmenü von anderen Spielern anzeigen oder herunterladen zu lassen.
                </p>


                <br class="no-move"/>
                <br class="no-move"/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <div class="container-small">
            <div class="orange-blass-wait">

                <br class="no-move"/>
                <br class="no-move"/>

                <h1 class="display-title-strong text-dark">

                    Setzte kreative Namen über dem Kopf.

                </h1>

                <p class="normal-text-title text-dark container">
                    Einen persönlichen und <strong>exklusiven oder spannenden Text</strong> unter deinem Namen. Der für
                    jeden LabyHelp Spieler sichtbar ist.
                </p>


                <br class="no-move"/>
                <br class="no-move"/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <h1 class="display-title-strong text-dark">

            LabyHelp bietet viele weitere Funktionen.

        </h1>

        <p class="display-title-middle text-dark container">Auf unserem <a
            href="https://www.youtube.com/channel/UCITHI08Diri9w4DS_2SZU8w">Youtube</a>, <a
            href="https://www.tiktok.com/@labyhelp_addon">TikTok</a> oder <a href="https://instagram.com/labyhelp">Instagram</a>
            Kanal findest du spannende weitere Einblicke oder du besuchst unseren <a href="https://labyhelp.de/discord">Discord
                Server</a> um keine neuen Updates mehr zu verpassen.</p>

        <br class="no-move"/>
        <br class="no-move"/>

        <div class="container-small">
            <div class="purple-blass-wait">

                <br class="no-move"/>
                <br class="no-move"/>

                <h1 class="display-title-strong text-dark">

                    Profil Seite

                </h1>

                <p class="normal-text-title text-dark ">
                    Auf unserer <a href="https://labyhelp.de/p.php">Profil Seite</a> kannst du die Social Media oder
                    Likes, Invites der LabyHelp Spieler sehen.
                </p>


                <br class="no-move"/>
                <br class="no-move"/>

            </div>

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <div class="creppy-white-blass-wait">

            <br class="no-move"/>
            <br class="no-move"/>

            <h1 class="display-title-strong text-white">

                Worauf wartest du?

            </h1>

            <p class="display-title-middle text-white container">
                Erlebe ab jetzt tolle Dinge mit dem LabyHelp Addon.
            </p>


            <b-button href="https://labyhelp.de/download" type="button" class="gray-shadow smaller-end-text"
                      variant="light">
                <fai :icon="['fas', 'download']" size="1x"/>
                <strong>Herunterladen</strong>
            </b-button>

            <br class="no-move"/>
            <br class="no-move"/>
            <br class="no-move"/>

        </div>

        <br class="no-move"/>
        <br class="no-move"/>

        <div class="" style="alignment: bottom">
            <p class="smaller-end-text">© {{ today.getFullYear() }}
                <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                <a style="color: #6868b3" href="https://labyhelp.de/imprint">Imprint</a> -
                <a style="color: #6868b3"
                   href="https://labyhelp.de/apply">Apply</a>
                -
                <a style="color: #6868b3"
                   target="_blank" href="https://stats.uptimerobot.com/ZrV89sM1jA">Status</a>
                -
                <a style="color: #6868b3"
                   href="ts3server://labyhelp.de">TeamSpeak</a>
                -
                <a style="color: #6868b3"
                   href="https://labyhelp.de/partner">Partner</a>
                -
                <a style="color: #6868b3"
                   href="https://labyhelp.de/team">Unser Team</a>
                -
                <a style="color: #6868b3"
                   href="https://labyhelp.de/branding">Branding</a>
                -
                <a style="color: #6868b3"
                   href="https://labyhelp.de/dashboard/index.php">Team Login</a>
            </p>
        </div>

    </div>
</template>

<script>
export default {
    name: "Index",
    data() {
        return {
            today: new Date()
        }
    },
}
</script>

<style scoped>

</style>